/* Mr Car Mats — finder behaviours. No dependencies, no build step.
   Two small jobs:
     1. the registration plate input (formatting + the two hero tabs)
     2. the model filter on manufacturer pages (type-ahead + A–Z)
   Both degrade to plain, working HTML if this file fails to load. */
(function () {
  'use strict';

  /* ---- 1. registration plate ------------------------------------------- */
  function initPlate(root) {
    var input = root.querySelector('.afb-plate__input');
    if (!input) return;
    input.addEventListener('input', function () {
      var raw = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
      // UK current format is 4 characters then 3, e.g. AB12 CDE
      input.value = raw.length > 4 ? raw.slice(0, 4) + ' ' + raw.slice(4) : raw;
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('.afb-finder__tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* ---- 2. model filter -------------------------------------------------- */
  function initModels(root) {
    var search = root.querySelector('.afb-search');
    var list   = root.querySelector('.afb-models');
    if (!list) return;
    var items  = Array.prototype.slice.call(list.querySelectorAll('.afb-model'));
    var azBtns = Array.prototype.slice.call(root.querySelectorAll('.afb-az button'));
    var empty  = root.querySelector('.afb-models__empty');
    var letter = '';

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (li) {
        var name = li.getAttribute('data-name') || '';
        var okQ = !q || name.indexOf(q) !== -1;
        var okL = !letter || name.charAt(0) === letter;
        var show = okQ && okL;
        li.hidden = !show;
        if (show) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    }

    if (search) search.addEventListener('input', apply);
    azBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = (btn.getAttribute('data-letter') || '').toLowerCase();
        letter = letter === val ? '' : val;
        azBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn && letter !== ''));
        });
        apply();
      });
    });
  }

  function boot() {
    document.querySelectorAll('.afb-finder').forEach(function (el) {
      initPlate(el); initTabs(el);
    });
    document.querySelectorAll('.afb-plate').forEach(function (el) { initPlate(el.parentNode || el); });
    document.querySelectorAll('.afb-modelblock').forEach(initModels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  // Shopify's theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', boot);
})();
